import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

/**
 * Ince, jilet gibi bir hukuki footer şeridi. Login / Signup / ForgotPassword
 * gibi auth sayfalarının en altına oturur — dükkan sahibinin KVKK, Kullanım
 * Koşulları ve Mesafeli Satış metinlerine tek tıkla ulaşması için.
 */
export default function LegalStrip({ className = "" }) {
  const linkCls = "hover:text-white transition-colors";
  return (
    <div
      className={`border-t border-white/8 mt-6 pt-4 pb-3 text-[10px] font-mono tracking-wider text-neutral-500 ${className}`}
      data-testid="legal-strip"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 leading-relaxed">
        <Link to="/legal/mesafeli-satis" className={linkCls} data-testid="legal-strip-mesafeli">Mesafeli Satış</Link>
        <span className="text-neutral-700 hidden sm:inline">·</span>
        <Link to="/legal/gizlilik-kvkk" className={linkCls} data-testid="legal-strip-kvkk">KVKK</Link>
        <span className="text-neutral-700 hidden sm:inline">·</span>
        <Link to="/legal/kullanim-kosullari" className={linkCls} data-testid="legal-strip-terms">Kullanım Koşulları</Link>
        <span className="text-neutral-700 hidden sm:inline">·</span>
        <Link to="/legal/iptal-iade" className={linkCls} data-testid="legal-strip-iptaliade">İptal / İade</Link>
        <span className="text-neutral-700 hidden sm:inline">·</span>
        <Link to="/iletisim" className={linkCls} data-testid="legal-strip-iletisim">İletişim</Link>
      </div>
      <div className="mt-2.5 flex items-center justify-center gap-1.5 text-neutral-600">
        <ShieldCheck size={10} style={{ color: "var(--gold)" }} />
        <span>© 2026 MilyemSoft - Mustafa Yıldız · Tüm Hakları Saklıdır.</span>
      </div>

      {/* Türk Patent Enstitüsü marka bandı — auth sayfalarında da güven mührü */}
      <div className="mt-3 flex justify-center" data-testid="legal-strip-tpe">
        <div
          className="inline-flex items-center gap-2 px-3 py-1.5 border text-[10px] font-mono tracking-widest uppercase"
          style={{
            borderColor: "rgba(212,175,55,0.28)",
            background: "linear-gradient(90deg, rgba(212,175,55,0.04), rgba(212,175,55,0.10), rgba(212,175,55,0.04))",
            color: "var(--gold)",
          }}
        >
          <span style={{ fontFamily: "serif" }}>MİLYEMSOFT®</span>
          <span className="text-neutral-500">·</span>
          <span className="text-neutral-400 normal-case">Türk Patent Enstitüsü nezdinde marka başvurusu kayıtlıdır</span>
        </div>
      </div>
    </div>
  );
}
